module.exports = __webpack_public_path__ + "static/media/search.7ad5bb29.svg";